import { render, staticRenderFns } from "./promo_codes_discounts.vue?vue&type=template&id=151f0ca1&scoped=true&"
import script from "./promo_codes_discounts.vue?vue&type=script&lang=js&"
export * from "./promo_codes_discounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151f0ca1",
  null
  
)

export default component.exports